

















import { Prop, Component, Vue } from "vue-property-decorator";
import { TaskGroup } from "@/api/task-api";

@Component({})
export default class VTaskGroup extends Vue {
  @Prop({ required: true }) taskGroup!: TaskGroup;

  get type() {
    return this.taskGroup.taskType ? this.taskGroup.taskType : "未定";
  }

  get name() {
    const name =
      (this.taskGroup.company ? this.taskGroup.company.name : "") +
      (this.taskGroup.office ? this.taskGroup.office.name : "");
    return name ? name : "未定";
  }

  get staffName() {
    return this.taskGroup.staff ? this.taskGroup.staff.name : "未定";
  }
}
